import {groundHeightAt,type ArenaDefinition,type Vec3} from './arena.ts';

export const VIRGILIO_RANGE=8;
/** The server resolves the surface and never trusts a client-supplied height. */
export function virgilioTarget(arena:ArenaDefinition,source:Vec3,x:number,z:number):Vec3|null{
  if(!Number.isFinite(x)||!Number.isFinite(z)||Math.hypot(x-source.x,z-source.z)>VIRGILIO_RANGE)return null;
  const y=groundHeightAt(arena,x,z,source.y+5.01);
  if(y===null || Math.abs(y-source.y)>5)return null;
  return {x,y,z};
}

/** Large structures take several Supremas; small scenery still shatters. */
export function danteSlamPropDamage(kind:string,hp:number):number{
  return ['crypt','shack','statue'].includes(kind)?Math.ceil(hp*.25):hp;
}
